import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { handleEntraRedirect, hasPendingEntraRedirectResponse } from './services/entraAuth';
import { getRuntimeEnvValue } from './config/runtimeConfig';
import './styles/main.css';

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

async function bootstrap() {
  try {
    const mode = (getRuntimeEnvValue('VITE_AUTH_MODE') || 'local').toLowerCase();
    if ((mode === 'entra' || mode === 'hybrid') && hasPendingEntraRedirectResponse()) {
      await handleEntraRedirect();
    }
  } catch (err) {
    console.error('Entra bootstrap redirect processing failed:', err);
  } finally {
    renderApp();
  }
}

void bootstrap();
